import { render } from "./FooterPage.vue?vue&type=template&id=6c9eb9ee&scoped=true"
const script = {}

import "./FooterPage.vue?vue&type=style&index=0&id=6c9eb9ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.32_webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9eb9ee"]])

export default __exports__